export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-960-3fef7ec087801ed16e940e74fab53f3d.png";